import outletmaster from "../services/reports.outlet";
import notification from "../services/notification";

export default {
    namespaced: true,

    state: {
        loading: false,
        error: false,
        errors: {},
        list: [],
        filters: null,
        import: false,
        importfile: null,
        importBase: null,
        uploading: false,
        year: null,
        yearFilters: [],
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        param: {
            param: {
                keyword: null,
                filter: null,
                year: new Date().getFullYear().toString(),
                status: null
            },
            limit: (new Date().getMonth() + 1).toString(),
            page: 1
        },
        confirm: false,
        data_errors: null,
        curr_year: new Date().getFullYear().toString()
    },

    mutations: {
        loading(state, value) {
            state.loading = value;
        },
        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
        },
        setList(state, list) {
            state.list = list;
        },
        setImportOutlet(state, importfile) {
            state.importfile = importfile;
        },
        setImportOutletBase(state, importBase) {
            state.importBase = importBase;
            state.import = true;
        },
        setImportOutletDefault(state) {
            state.importBase = null;
            state.import = false;
        },
        setUploading(state, status) {
            state.uploading = status;
        },
        setFilters(state, filters) {
            state.filters = filters;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            let response = pagination.response;
            state.pagination.totalPerPage = response.list.length;
            state.pagination.maxPage = state.pagination.totalPerPage > 0 ? response.max_page : 0;
            state.pagination.prevPage = response.prev_page;
            state.pagination.nextPage = response.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount * state.pagination.prevPage + 1
                    : 0;
            if (state.param.param.year < state.curr_year) {
                state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem + (state.pagination.totalPerPage * 12) - 1
                    : 0;
            } else {
                state.pagination.currentLastItem =
                    state.pagination.currentFirstItem > 0
                        ? state.pagination.currentFirstItem + (state.pagination.totalPerPage * state.param.limit) - 1
                        : 0;
            }
        },
        setParam(state, param) {
            state.loading = true;
            state.param = param;
            state.loading = false;
        },
        setConfirmModal(state, status) {
            state.confirm = status;
        },
        setYear(state, year) {
            state.year = year;
        },
        setYears(state, years) {
            state.yearFilters = years;
        },
        setMismatchRows(state, rows) {
            if (rows !== null) {
                state.data_errors = {
                    field_errors: rows.field_errors,
                    mismatch_col: rows.mismatch_col,
                };
            } else {
                state.data_errors = rows;
            }
        }
    },

    actions: {
        getList: async ({ commit, state }, param) => {
            commit("loading", true);
            try {
                let response = await outletmaster.getList(param);

                let list = response.list;
                let new_list = [];

                list.forEach(function(row) {
                    let months = Object.keys(row.month_fy);
                    let month_fy = Object.values(row.month_fy);
                    let year_fy = Object.values(row.year_fy);
                    let cab_fy = Object.values(row.cab_count);
                    let cu_ft_fy = Object.values(row.cu_ft);
                    let discount_fy = Object.values(row.discount);
                    let i = 0;

                    let m = [];
                    if (param.param.year < state.curr_year) {
                        while (i < 12) {
                            m.push(months[i]);
                            i++;
                        }
                    } else {
                        while (i < param.limit) {
                            m.push(months[i]);
                            i++;
                        }
                    }
                    
                    m.forEach(function(month) {
                        while (i < param.length) {
                            i++;
                        }
                        new_list.push({
                            cab_count: cab_fy[month - 1],
                            contact_person: row["contact_person"],
                            created_on: row["created_on"],
                            cu_ft: cu_ft_fy[month - 1],
                            discount: discount_fy[month - 1],
                            email: row["email"],
                            email_customer: row["email_customer"],
                            isr_code: row["isr_code"],
                            merchant_name: row["merchant_name"],
                            membership_id: row["membership_id"],
                            merchant_uuid: row["merchant_uuid"],
                            month: month,
                            month_created: row["month_created"],
                            month_fy: month_fy[month - 1],
                            new_major_channels: row["new_major_channels"],
                            outlet_code: row["outlet_code"],
                            phone: row["phone"],
                            phone_customer: row["phone_customer"],
                            status: row["status"],
                            sub_type: row["sub_type"],
                            sub_type_description: row["sub_type_description"],
                            uuid: row["uuid"],
                            year: row["year"],
                            year_fy: year_fy[month - 1]
                        });
                    });
                });

                if (param.page === 1) {
                    await commit("setInitialPageCount", new_list.length);
                }

                commit("setList", new_list);
                commit("setPagination", { new_list, response });
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        exportXls: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await outletmaster.exportXls(param);
                commit("loading", false);
                notification.success(response.message);
                window.open(response.url);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        exportPdf: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await outletmaster.exportPdf(param);
                commit("loading", false);
                notification.success(response.message);
                window.open(response.url);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        importOutlet: async ({ commit, state }) => {
            commit("loading", true);
            // commit("setUploading", true);
            notification.info("File is currently uploading");

            try {
                let response = await outletmaster.importOutlet({
                    tsv: state.importBase.split(",").pop()
                });
                // let status = response.stats;
                // if (
                //     status.success > 0 &&
                //     status.errors.field_errors.length === 0 &&
                //     status.errors.mismatch_col.length === 0
                // ) {
                //     notification.success(response.message);
                // } else if (
                //     status.errors.field_errors.length === 0 &&
                //     status.errors.mismatch_col.length === 0 &&
                //     status.success === 0
                // ) {
                //     notification.warning(
                //         "You have entered an invalid format. Please check the format and try again."
                //     );
                // } else {
                //     await commit("setMismatchRows", status.errors);
                //     notification.warning(
                //         "You have an invalid field within the tsv file. Please check the file and try again."
                //     );
                // }
                commit("setImportOutletDefault");
                commit("loading", false);
                commit("setUploading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                commit("setUploading", false);
                notification.warning("Oops, cannot upload Outlet Master.");
            }
        },

        readImportOutlet: async ({ commit, state }) => {
            commit("loading", true);

            let reader = new FileReader();
            reader.readAsDataURL(state.importfile);

            reader.onload = e => {
                commit("setImportOutletBase", e.target.result.substring(21));
            };
        },

        getFilters: async ({ commit }) => {
            commit("loading", true);
            try {
                let response = await outletmaster.getFilters();
                commit("setFilters", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        getYears: async ({ commit }) => {
            commit("loading", true);
            try {
                let response = await outletmaster.getYears();
                let list = response.filters;
                let new_list = [];

                list.forEach(function(year) {
                    let item = {
                        value: year,
                        text: year
                    };

                    new_list.push(item);
                });

                commit("setYear", new_list[0].value);
                commit("setYears", new_list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
